<template>
  <div class="listFacilities">
    <v-card>
      <v-card-title>
        Facilities
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('GeneralTranslations.Search')"
          single-line
          hide-details
          style="max-width: 300px; margin-top: 15px;"
        ></v-text-field>

        <v-dialog v-model="orgDialog" persistent max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on" class="ml-5 mt-5">Create Org</v-btn>
          </template>
          <v-card>
            <validation-observer ref="observer" v-slot="{ invalid }">
              <v-card-title>
                <span class="headline">Create Organisation</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <validation-provider v-slot="{ errors }" name="OrgName" rules="required">
                        <v-text-field v-model.trim="newOrgName" label="Org Name*" :error-messages="errors"></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12">
                      <validation-provider v-slot="{ errors }" name="OrgHubspotId" rules="required">
                        <v-text-field v-model.trim="refId" label="Org PCSCID*" :error-messages="errors"></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                </v-container>
                <small>{{$t('GeneralTranslations.StarIndicatesRequiredField')}}</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancelOrgCreatePopup">{{$t('GeneralTranslations.Cancel')}}</v-btn>
                <v-btn color="blue darken-1" type="submit" text @click="createOrg" :disabled="invalid">{{$t('GeneralTranslations.Create')}}</v-btn>
              </v-card-actions>
            </validation-observer>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog" persistent max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on" class="ml-5 mt-5">Create Facility</v-btn>
          </template>
          <v-card>
            <validation-observer ref="observer" v-slot="{ invalid }">
              <v-card-title>
                <span class="headline">Create Facility</span>
              </v-card-title>
              <v-card-text>
                <v-container v-if='creatingFacility'>
                  <div class="text-center">
                    <v-progress-circular
                      :size="70"
                      :width="7"
                      color="purple"
                      indeterminate
                    ></v-progress-circular>
                    Creating facilty, this takes 8 seconds..
                  </div>
                </v-container>
                <v-container v-else>
                  <v-row>
                    <v-col cols="12">
                      <validation-provider v-slot="{ errors }" name="Name" rules="required">
                        <v-text-field v-model="newFacilityName" label="Name*"  :error-messages="errors"></v-text-field>
                      </validation-provider>

                      <validation-provider v-slot="{ errors }" name="Organisation" rules="required">
                        <v-autocomplete v-model="newOrg" :items="buddyOrganisationsList" return-object item-text="name" item-value="id" label="Organisation*" @change="getRegions"  :error-messages="errors"></v-autocomplete>
                      </validation-provider>
                        
                      <v-select v-model="newRegion" v-if="newOrg !=null" return-object :items="regions" item-text="name" label="Region"></v-select>

                      <validation-provider v-slot="{ errors }" name="BaseUrl" rules="required">
                        <v-text-field 
                          v-model="newBaseUrl" 
                          label="Base Url*" 
                          placeholder="example-staffhub.web.app"
                          :error-messages="errors"
                        ></v-text-field>
                      </validation-provider>
                      <small class="ml-3 grey--text small-tight">Enter domain without https:// protocol</small>

                      <v-text-field class="pt-2" v-model="familyHubAppName" required label="FamilyHub App name"></v-text-field>
                      <v-text-field v-model="linkToFamilyHubForAndroid" required label="Link to FamilyHub for Android"></v-text-field>
                      <v-text-field v-model="linkToFamilyHubForIos" required label="Link to FamilyHub for iOS"></v-text-field>
                      <v-text-field v-model="newRefId" label="Ref Id" dense hide-details="auto"></v-text-field>
                      <small class="ml-3 grey--text">Ref ID is the Hubspot Location ID if integrating with MCare.</small>

                      <v-autocomplete multiple v-model="selectedFeatureBundles" :items="featureBundlesList" class="pt-5" label="Feature bundles"></v-autocomplete>

                    </v-col>
                  </v-row>
                  <small>{{$t('GeneralTranslations.StarIndicatesRequiredField')}}</small>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancelFacilityCreatePopup">{{$t('GeneralTranslations.Cancel')}}</v-btn>
                <v-btn type="submit" color="blue darken-1" :loading="isCreatingFacilityLoading"  text @click="createFacility" :disabled="invalid">{{$t('GeneralTranslations.Create')}}</v-btn>
              </v-card-actions>
            </validation-observer>
          </v-card>
        </v-dialog>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="buddyFacilities"
        :loading="isFacilitiesLoading"
        :search="search"
        @click:row="handleClickFacility"
      >
      <template v-slot:item.dateTimeCreated="{ item }">
          <span v-if="item.dateTimeCreated">{{ (item.dateTimeCreated.seconds * 1000)| localizedDate(facility.dateFormat) }}</span>
      </template>
      
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { UserTypeEnum } from "@/enums/UserTypeEnum";
import { FeatureBundles } from "@/enums/FeatureBundles";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { AuditLogsTier1 as Tier1, AuditLogsTier2 as Tier2, AuditLogsTier3 as Tier3 } from '@/enums/AuditLogs';
import { setFacilityFeatureBundles } from "@/utils/facility/setFacilityFeatureBundles";
import * as firebase from "firebase/app";

export default {
  name: "facilitiesList",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  computed: mapState({
    regions: (state) => state.buddyModule.currentRegions,
    facility: (state) => state.facilityModule.selectedFacility,
    currentUser: (state) => state.authModule.user,
  }),
  data() {
    return {
      dialog :false,
      orgDialog:false,
      isCreatingFacilityLoading: false,
      isFacilitiesLoading: false,
      currentDate: new Date().getDate(),
      search: "",
      newFacilityName: "",
      newBaseUrl: "",
      newRefId: "",  //hubspotId
      familyHubAppName: "",
      linkToFamilyHubForAndroid: "",
      linkToFamilyHubForIos: "",
      creatingFacility: false,
      newOrg: null,
      buddyFacilities: [],
      buddyOrganisationsList: [],
      newOrgName: null,
      featureBundlesList: Object.values(FeatureBundles),
      selectedFeatureBundles: [],
      previousSelection: [],
      refId: null,
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "Region",
          align: "start",
          sortable: false,
          value: "regionName",
        },
        {
          text: "Organisation",
          align: "start",
          sortable: false,
          value: "orgName",
        },
        {
          text: "Creation date",
          align: "start",
          sortable: false,
          value: "dateTimeCreated",
        },

      ],
    };
  },
  async created() {
    this.isFacilitiesLoading = true;
    const projectId = firebase.app().options['projectId'];
    this.setDefaultFacilityValues(projectId)
    this.buddyFacilities = await this.$store.dispatch("getBuddyFacilities");
    this.isFacilitiesLoading = false;
    this.buddyOrganisationsList = await this.$store.dispatch("getBuddyOrgs");
  },
  methods: {
    setDefaultFacilityValues(projectId){
      const hostname = window.location.hostname;
      this.newBaseUrl = hostname === 'localhost' ? 'test-staffhub.firebaseapp.com' : hostname;
      if(projectId === 'reshub'){
          this.familyHubAppName = "PCS FamilyHub"
          this.linkToFamilyHubForAndroid =  "https://play.google.com/store/apps/details?id=com.reshub.pcs",
          this.linkToFamilyHubForIos = "https://apps.apple.com/us/app/pcs-familyhub/id6482482330"
      }
    },
    handleClickFacility(row) {
      console.log(row)
      this.$store.dispatch('getFacilitiesForOrg', row.orgId);
      this.$store.dispatch('getFacilityEmailTemplates', row.id);
      this.$router.push("/buddy/facilities/" + row.id.toString());
    },
    async createFacility(){
      try {
        this.isCreatingFacilityLoading = true
      
        const newFacility = {
          name: this.newFacilityName, 
          baseUrl: this.newBaseUrl, 
          refId: this.newRefId,
          regionId: this.newRegion?.id || null,
          regionName: this.newRegion?.name || null, 
          orgId: this.newOrg.id, 
          orgName: this.newOrg.name,
          createdById: this.currentUser.id,
          createdByType: UserTypeEnum.Staff,
          initiatorAccessLevel: this.currentUser.accessLevel,
          initiatorName: this.currentUser.name,
          familyHubAppName: this.familyHubAppName,
          linkToFamilyHubForAndroid: this.linkToFamilyHubForAndroid,
          linkToFamilyHubForIos: this.linkToFamilyHubForIos,
          typesOfRecordChanged: [`${Tier1.StaffHubSettings}: ${Tier2.StaffSettings}: ${Tier3.MailingLists}`]
        }

        if(this.selectedFeatureBundles.length){
          setFacilityFeatureBundles(newFacility, this.selectedFeatureBundles, true)
        }

        await this.$store.dispatch("createBuddyFacility", newFacility);
        this.newOrg = null;
        this.newRegion=null;
        this.creatingFacility= true;
        this.newFacilityName = null;
        this.newBaseUrl = null;
        this.newRefId = null;
        this.isCreatingFacilityLoading = false
        this.dialog = false
      } catch (error) {
        console.error("Error creating facility:", error)
      } finally {
        this.creatingFacility = false;
        console.log('here')
      }
    },
    async createOrg(){
      await this.$store.dispatch("createBuddyOrg", { name: this.newOrgName, refId: this.refId });
      this.orgDialog = false;
      this.buddyOrganisationsList = await this.$store.dispatch("getBuddyOrgs");
      this.newOrgName = null;
      this.refId = null;
    },
    getRegions(){
      this.$store.dispatch("getBuddyRegions",  this.newOrg.id);
    },
    cancelFacilityCreatePopup(){
      //  this.dialog = false;
      this.newOrg = null;
      this.newRegion=null;
      this.newFacilityName = null;
      this.newBaseUrl = null;
      this.newRefId = null;
      this.dialog= false;
    },
    cancelOrgCreatePopup(){
      this.orgDialog = false;
      this.newOrgName = null;
      this.refId = null;
    }
  },
};
</script>

<style scoped>
  .small-tight {
  margin-top: -4px;
  display: block;
}
</style>
